import { combineReducers } from 'redux';
import Base from './Base';
import Org from './Org';

const rootReducer = combineReducers({
  Base,
  Org,
});

export default rootReducer;